import FormComponent from '../../Form'
import Api from '../../Api'
import SearchComponent from '../../Form/search'
import { ROLE_ROOT } from '../../../constants/roles'
import labels from '../../Common/translations'

export default {
   mode: FormComponent.MODE_SEARCH,
   fields: {
      search: {
         type: FormComponent.GROUP,
         fields: {
            keywords: {
               label: labels.fields.name,
               search: {
                  mode: SearchComponent.BEGINS_WITH,
               },
               options: {
                  autoComplete: 'off',
               },
            },
            partner: {
               label: labels.fields.partner,
               hidden: ({ authUser }) => authUser.role !== ROLE_ROOT,
               // options: {
               //    emptyValue: ({ authUser }) => authUser.role === ROLE_ROOT,
               // },
               type: FormComponent.SELECT,
               values: {
                  from: 'state',
                  prop: 'partnerValues',
                  collection: 'companies',
                  source: () =>
                     Api.selectValues('companies', {
                        q: { isPartner: [true] },
                        fsort: 'name',
                     }),
               },
               return: FormComponent.FORMAT_OBJECT,
            },
         },
      },
   },
   buttons: {
      submit: {
         label: labels.fields.search,
         icon: 'search',
      },
      cancel: {
         label: labels.fields.reset,
         icon: 'undo',
      },
      extras: [],
   },
   actions: {},
   extras: [],
}
